import React from "react";

export default function DashboardTopSearch() {
  return (
    ""
    // <form className="dashboard-top-search flex-grow-1">
    //     <input
    //       type="text"
    //       placeholder="Search from courses..."
    //       className="form-control pe-40"
    //     />
    //     <span className="icon-search position-absolute text-base"></span>
    // </form>
  );
}
